import type {StarterGroup} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import decoupledTaskStarters from '../../data/decoupled-task-starters.json'
import starters from '../../data/starters.json'
import updatedStarters from '../../data/updated-starters.json'

const chronicleStarterGroup = {
  id: 'improve-my-workflow',
  name: 'Improve my workflow',
  color: 'var(--display-gray-fgColor)',
  icon: 'terminal',
  entries: [
    {
      id: 'improve-workflow',
      message:
        'Use /chronicle tips to review my session history and recommend personalized tips based on my usage patterns.',
      titleHtml: 'Improve my workflow',
    },
  ],
} as StarterGroup

export function getStarterGroups(useUpdatedStarters = false, useTaskStarters = false): StarterGroup[] {
  if (useTaskStarters) {
    const groups = Object.values(decoupledTaskStarters) as StarterGroup[]
    if (isFeatureEnabled('copilot_mission_control_chronicle_commands')) {
      // Replace the "Improve test coverage" entry (slot 1) with the Chronicle entry
      return [groups[0]!, chronicleStarterGroup, ...groups.slice(2)]
    }
    return groups
  }
  return Object.values(useUpdatedStarters ? updatedStarters : starters) as StarterGroup[]
}
